import React, { useState, useEffect } from 'react';
import './NftList.css';
import NftCard from './NftCard';

function NftList({ nfts, onSelect, currentTab, setTab }) {
  const [activeId, setActiveId] = useState(null);
  const [canvasSize, setCanvasSize] = useState({ width: 1920, height: 1080 });

  const updateCanvasSize = () => {
    const canvas = document.querySelector('.game-canvas');
    if (canvas) {
      setCanvasSize({
        width: canvas.offsetWidth,
        height: canvas.offsetHeight,
      });
    }
  };

  useEffect(() => {
    updateCanvasSize();

    window.addEventListener('resize', updateCanvasSize);
    const observer = new MutationObserver(() => requestAnimationFrame(updateCanvasSize));

    const canvas = document.querySelector('.game-canvas');
    if (canvas) {
      observer.observe(canvas, { attributes: true });
    }

    return () => {
      window.removeEventListener('resize', updateCanvasSize);
      observer.disconnect();
    };
  }, []);

  const getPosition = (type, index, canvasWidth, canvasHeight) => {
    const maxCards = 8;
    const offsetX = (canvasWidth * 0.08) / maxCards;
    const offsetY = (canvasHeight * 0.22) / maxCards;

    const basePositions = {
      Farm: { left: canvasWidth * 0.025, top: canvasHeight * 0.15 },
      Tool: { left: canvasWidth * 0.025, top: canvasHeight * 0.58 },
      Ranch: { left: canvasWidth * 0.81, top: canvasHeight * 0.58 },
    };

    const base = basePositions[type] || { left: 0, top: 0 };

    return {
      left: `${base.left + index * offsetX}px`,
      top: `${base.top + index * offsetY}px`,
    };
  };

  const sortedNfts = nfts.slice().sort((a, b) => {
    if (a.type !== b.type) return 0;
    if (a.asset_id === activeId) return 1;
    if (b.asset_id === activeId) return -1;
    return 0;
  });

  const grouped = { Farm: [], Tool: [], Ranch: [] };
  sortedNfts.forEach(nft => {
    if (grouped[nft.type]) grouped[nft.type].push(nft);
  });

  return (
    <div className="nft-list-container">
      {Object.entries(grouped).flatMap(([type, group]) =>
        group.map((nft, index) => (
          <NftCard
            key={nft.asset_id}
            nft={nft}
            isActive={activeId === nft.asset_id}
            onClick={() => {
              if (currentTab === 'home') {
                setActiveId(nft.asset_id);
                onSelect(nft);
              } else {
                setTab('home');
                setTimeout(() => {
                  setActiveId(nft.asset_id);
                  onSelect(nft);
                }, 0);
              }
            }}
            
            onClose={() => setActiveId(null)}
            onClaim={() => alert(`Claimed ${nft.asset_id}`)}
            style={getPosition(type, index, canvasSize.width, canvasSize.height)}
          />
        ))
      )}
    </div>
  );
}

export default NftList;
